import $ from "jquery";
import axios from "axios";

(() => {
    const tax_switch = {
        init: function(){
            $('body').on('click', '[data-cart="row"] .tax-select span', function(){
                var self = $(this),
                    show_without_tax = self.hasClass('show-no-tax'),
                    row = self.parents('[data-cart="row"]'),
                    prices = row.find('.cart-price, .cart-price__detail');
                
                prices.hide();

                if (show_without_tax) {
                    prices.filter('.cart-price--no-tax').show();
                } else {
                    prices.filter('.cart-price--tax').show();
                }
            });            
        }
    }.init();
    const cart = {
        init: function () {
            const _self = this,
                count_cont = $('.js-cart-count');
            $('body')
                .on('click', '.js-cart-add, .js-cart-delete', function (e) {
                    e.preventDefault();
                    const $this = $(this),
                        was = $this.hasClass('js-cart-delete'),
                        quantity = $this.data('quantity') ? $($this.data('quantity')).val() : undefined;
                    axios.post(route('catalog.cart.' + (was ? 'delete' : 'add'), $this.data('id')), {
                        _method: was ? 'DELETE' : 'POST',
                        quantity: quantity
                    })
                        .then(response => {
                            if (response.data.status === 'ok') {
                                count_cont.text(response.data.count);
                                if (typeof response.data.message !== 'undefined') {
                                    new Noty({
                                        text: response.data.message,
                                        type: 'success'
                                    }).show();
                                }
                            }
                        });
                })
                .on('change', 'input[data-cart="quantity"]', () => _self.update())
                .on('click', '[data-cart="remove"]', function () {
                    $(this).closest('[data-cart="row"]').remove();
                    _self.update();
                })
                .on('click', '.js-cart-clear', (e) => {
                    e.preventDefault();
                    _self.clear();
                });
                
            $('.catalog-item-detail__qty .btn-qty')
                .off()
                .on('click', function (e) {
                    const $_ = $(this),
                        qty = $_.parent().find('.qty'),
                        curVal = parseInt(qty.val());

                    if ($_.hasClass('qty-down') && curVal > 1) {
                        qty.val(curVal - 1);
                    }
                    if ($_.hasClass('qty-up')) {
                        qty.val(curVal + 1);
                    }
                    qty.trigger('change');
                });
        },
        clear: function () {
            axios.post(route('catalog.cart.clear'), {_method: 'DELETE'})
                .then((response) => {
                    if (response.data.status === 'ok') {
                        window.location.href = route('catalog.category.index');
                    }
                });
        },
        update: function () {
            const _self = this,
                rows = $('[data-cart="row"]');
            let data = {};
            rows.each(function () {
                const $_ = $(this);
                data[$_.data('cart-id')] = $_.find('input[data-cart="quantity"]').val();
            });
            axios.post(route('catalog.cart.update'), {cart: data})
                .then(response => {
                    if (response.data.status === 'ok') {
                        _self.updateView(rows, response.data.data);

                        new Noty({
                            text: 'Содержимое корзины обновлено',
                            type: 'success'
                        }).show();
                    }
                })
        },
        updateView: function (rows, data) {
            $('[data-cart="formatted_total"]').text(data.formatted_total);
            $('[data-cart="total"]').text(data.total);
            $('.js-cart-count').text(data.total_count);
            rows.filter(function () {
                return data.item_ids.includes($(this).data('cart_id'));
            }).remove();
            $.each(data.items, (product_id, product) => {
                const row = rows.filter('[data-cart-id="' + product_id + '"]');
                row.find('[data-cart]').each(function () {
                    const $_ = $(this),
                        type = $_.data('cart');
                    if (type === 'quantity-hide') {
                        if (product.quantity > 1) {
                            $_.removeClass('display-none');
                        } else {
                            $_.addClass('display-none');
                        }
                    } else {
                        if ($_.is('input')) {
                            $_.val(product[type]);
                        } else {
                            $_.text(product[type]);
                        }
                    }
                });
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/cart.js